import { TagModel } from "@app/shared/services/gtm/model/tag.model";

export class EntryLocationTagModel extends TagModel {
  entryLocation: string;
}
